module.exports = __webpack_public_path__ + "static/a-tale-of-two-olympic-victories-3a65a7a8a98f6f58488a91bc560493b8.jpg";